import api from './api';


export const trackUxInteraction = (event) => {
  // Telemetria nunca deve bloquear navegação nem exibir erro para a usuária.
  api.post('/ux-telemetry/events', event).catch(() => {});
};
